/* eslint-disable react/require-default-props */
import { Avatar, Tooltip, TooltipProps } from '@material-ui/core'
import { CSSProperties } from 'react'
import { User, defaultOwners, GoalOwner } from 'TypeDefs/Goal'
import { NonprofitOrgUser } from 'TypeDefs/Team'
import { useAppState } from 'Context/AppContext/AppContext'
import GET_NONPROFIT_ORG_TEAM_QUERY from 'Apollo/Queries/GetNonprofitOrgTeam'
import { useQuery } from '@apollo/client'
import useStyles from './UserAvatar.styles'

interface IUserAvatarProps {
  user: User
  tooltipText?: string
  tooltipPosition?: TooltipProps['placement']
  cssProps?: CSSProperties
}

const UserAvatar = ({
  user,
  tooltipText,
  tooltipPosition,
  cssProps,
}: IUserAvatarProps) => {
  const classes = useStyles()
  const {
    nonprofitOrgConfig: { orgId, platformPlan },
  } = useAppState()

  const { data: teamData } = useQuery(GET_NONPROFIT_ORG_TEAM_QUERY, {
    variables: {
      nonprofitOrgId: orgId,
      planName: platformPlan,
    },
    skip: !orgId,
  })

  const getAvatarLetters = (
    firstName: string,
    lastName: string,
    userId?: number
  ) => {
    if (firstName !== defaultOwners[GoalOwner.ALL_TEAM_MEMBERS]) {
      if (firstName && lastName) {
        // user has logged in
        return `${firstName[0]}${lastName[0]}`.toUpperCase()
      }
      if (firstName) {
        // user has not logged in, show first two letters of email
        // this was nececssary to make the task ownership work
        return `${firstName[0]}${firstName[1]}`.toUpperCase()
      }
      // user has not logged in, show first two letters of email AFTER FETCHING IT
      // this was nececssary to make the goal ownership work
      const userWithoutName = teamData?.nonprofitOrgTeam?.users.find(
        (orgUser: NonprofitOrgUser) => orgUser.user.id === userId
      )
      if (userWithoutName) {
        return `${userWithoutName.user.email[0]}${userWithoutName.user.email[1]}`.toUpperCase()
      }
    }
    return 'All'
  }

  const getTooltipText = () => {
    if (tooltipText) return tooltipText
    if (
      user.firstName &&
      user.lastName &&
      user.firstName !== defaultOwners[GoalOwner.ALL_TEAM_MEMBERS]
    ) {
      return `Owned by ${user.firstName} ${user.lastName}`
    }
    if (user.firstName) {
      return `Owned by ${user.firstName}`
    }
    const userWithoutName = teamData?.nonprofitOrgTeam?.users.find(
      (orgUser: any) => orgUser.user.id === user.id
    )
    if (userWithoutName) {
      return `Owned by ${userWithoutName.user.email}`
    }
    return ''
  }

  return (
    <Tooltip
      classes={{
        tooltip: classes.avatarTooltip,
        arrow: classes.avatarTooltipArrow,
      }}
      title={getTooltipText() || ''}
      placement={tooltipPosition || 'top-end'}
      arrow
    >
      <Avatar className={classes.avatar} style={{ ...cssProps }}>
        {getAvatarLetters(user.firstName, user.lastName, user.id)}
      </Avatar>
    </Tooltip>
  )
}

export default UserAvatar
